import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HousingBuilderService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/housingbuilder";

  newhousingbuilder(housingbuilder: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, housingbuilder)
  }

  housingbuilderStatus(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllhousingbuilderDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  housingbuilderSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteByHousingbuilderId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/${id}`);
	} 

  downloadHousingbuilderTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, {responseType: 'arraybuffer',observe: 'response' });
  }
  downHousingbuilderReport(Page: number, size: number, sort,selectionUnits): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionUnits, { 
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

}
